import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RequestService} from '../../../handlers/request/request.service';
import {ResponseServiceOperationalInterface} from '../../models/operational/operational';
import {globalEnv} from '../../connection/global/global.env';
import {operationalApi} from '../../api/operational/operational.api';

@Injectable({
  providedIn: 'root',
})
export class OperationalService {

  constructor(private req: RequestService) {}

  getDeliveryHome(): Observable<ResponseServiceOperationalInterface> {
    const url = `${globalEnv.apiOperational}${operationalApi.deliveryHome}`;
    return this.req.get(url, null, null, null, null, true);
  }

}